<template>
<div>
  <v-layout>
    <v-flex xs12 class="display-1">
      Welcome To Adult Learn To Play
    </v-flex>
  </v-layout>
  <v-layout my-2 pl-1>
    <v-flex xs12 mx-1 px-3 py-1 style="background-color: #FFFFF9; border: 1px solid #fFFFFF0">
      <p>We just need some information to complete the registration process.</p>
    </v-flex>
  </v-layout>
  <v-layout row wrap pl-3 pt-2 pb-4>
    <v-flex xs12 pb-1>
    <span class="title">{{ event.name }}</span>
    </v-flex>
    <v-flex xs12 pb-1>
      <address>
        <span class="addr-name">{{ rink.name }}</span>
        <span class="addr-street">{{ rink.address }}</span>
        <span class="addr-area">{{ rink.city }} {{ rink.state }}, {{rink.zip }}</span>
      </address>
    </v-flex>
    <v-flex xs12 pb-1>
      <small v-show="hasSessions"><em>{{ hasSessions ? 'Event begins ' : '' }}</em></small>
      {{ eventDatetime }}
    </v-flex>
    <!-- <v-flex xs12><h5>Schedule</h5></v-flex>
    <v-layout row wrap v-for="session in event.sessions" :key="session.id">
      <v-flex xs3>
        {{ viewDate(session.date, true) }}
      </v-flex>
      <v-flex xs3>
        {{ viewTime(session.start) }}
      </v-flex>
      <v-flex xs3>
        {{ viewTime(session.end) }}
      </v-flex>
      <v-flex xs12>
        {{ session.notes }}
      </v-flex>
    </v-layout> -->
    <v-flex xs12 pb-1>
      <div class="alert-wrapper">
        <v-alert
          :value="waitlist"
          type="warning"
        >
          {{ $t('eventCard.waitlist') }}
        </v-alert>
      </div>
    </v-flex>
    <v-flex xs12 pb-1>
      <div class="alert-wrapper">
        <v-alert
          :value="soldout"
          type="error"
        >
          {{ $t('eventCard.soldout') }}
        </v-alert>
      </div>
    </v-flex>
    <v-flex v-show="!isAdult" shrink pb-1>
      <v-icon color="warning" class="px-2">
        warning
      </v-icon>
    </v-flex>
    <v-flex v-show="!isAdult" xs10 pb-1>
      <em>{{ ageRestriction }}</em>
    </v-flex>
    <v-spacer />
    <v-flex align-self-end shrink pl-5 pb-1 style="border-bottom: 2px dotted #eee;">
      <b>{{$t('eventCard.registration') }}</b>
    </v-flex>
    <v-spacer style="border-bottom: 2px dotted #eee;" />
    <v-flex align-self-end shrink class="text-xs-right pr-5" pb-1 style="border-bottom: 2px dotted #eee;">
      <b>${{ parseFloat(event.fee).toFixed(2) }}</b>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import * as date from '../../libs/js/dates'

export default {
  name: 'RegistrationIntro',
  computed: {
    isAdult () {
      return this.$store.state.team.is_adult_registration === 1
    },
    filteredEvents () {
      return this.$store.state.events.filter(ev => ev.id.toString() !== this.$route.params.id.toString())
    },
    event() {
      let e = this.$store.state.events.find(e => e.id.toString() === this.$route.params.id)
      if(e) return e
      else return { name: '', total: 0, description: '' }
    },
    rink() {
      if(this.event['location-id']) return this.$store.state.rinks.find(r => r.id === this.event['location-id'])
      else return { name: '', address: '', city: '', state: '', zip: '' }
    },
    hasRink() {
      return (this.event['location-id'] == true) && (this.$store.state.rinks.find(r => r.id === this.event['location-id']) == true)
    },
    hasSessions() {
      return Array.isArray(this.event.sessions) && this.event.sessions.length > 0
    },
    bdateMin() {
      let d = this.event['bdate-min'] || this.event['nhl-bdate-min']
      if(!d) d = '2010-12-31'
      return date.viewDate(d, this.$i18n.locale)
    },
    bdateMax() {
      let d = this.event['bdate-max'] || this.event['nhl-bdate-max']
      if(!d) d = '2013-07-01'
      return date.viewDate(d, this.$i18n.locale)
    },
    ageRestriction() {
      return this.$t('eventCard.bdateRestriction').replace('%1', this.bdateMin).replace('%2', this.bdateMax)
    },
    eventDatetime() {
      return date.viewDatetime(this.event['event-datetime'], this.$i18n.locale, this.rink.time_zone)
    },
    viewDate () {
      return (val, short) => date.viewDate(val, this.$i18n.locale, short)
    },
    viewDatetime() {
      return (val) => date.viewDatetime(val, this.$i18n.locale, this.rink.time_zone)
    },
    viewTime() {
      return (val) => date.viewTime(val, this.$i18n.locale, this.rink.time_zone)
    },
    waitlist () {
      if (this.event.id) {
        return this.event.status == 'active-waitlist' || this.event['open-spaces'] < 1
      } else {
        return false
      }
    },
    soldout () {
      if (this.event.id) {
        if (this.event.status == 'soldout') {
          return true
        }
        if ((this.event.status.indexOf('promo') !== -1) &&
          (this.event['open-spaces'] < 1) &&
          (this.$store.state.team.use_waitlist == 0)) {
            return true
        }
        return false
      } else {
        return false
      }
    },
    promote () {
      if (this.event.id) {
        if (this.event.status.indexOf('presale') !== -1) {
          return this.viewDate(this.event['registration-open'], false)
        } else {
          return false
        }
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
  address span {
    display: block;
    font-style: normal;
  }
</style>